/* eslint-disable no-restricted-syntax */
// Master list of slugs in the graph
export const SLUGS = {
  TRAILER_LAUNCH: 'trailer-boat-launch',
  CARRY_IN: 'carry-in-boat-launch',
  LAUNCH: 'boat-launch',
  RAMP: 'boat-ramp',
  TOILET: 'toilet',
  DOCK: 'dock',
  TRAILER_PARKING: 'trailer-parking',
  ADA_PARKING: 'ada-parking',
  SHORE_FISHING: 'shore-fishing',
  PIER_FISHING: 'pier-fishing',
  BANK_FISHING: 'bank-fishing',
  BREAKWATER_FISHING: 'breakwater-fishing',
  GRAVEL_RAMP: 'gravel-boat-ramp',
  PAVED_RAMP: 'paved-boat-ramp',
  NATURAL_RAMP: 'natural-boat-ramp',
  LARGEMOUTH_BASS: 'largemouth-bass',
  SMALLMOUTH_BASS: 'smallmouth-bass',
  BLUEGILL: 'bluegill',
  CRAPPIE: 'crappie',
  PERCH: 'perch',
  MUSKELLUNGE: 'muskellunge',
  NORTHERN_PIKE: 'northern-pike',
  RAINBOW_TROUT: 'rainbow-trout',
  WALLEYE: 'walleye',
  LAKE_TROUT: 'lake-trout',
}

// Master list of fields in the graph (used for filtering)
export const FIELDS = {
  AMENITIES: 'amenities',
  ACCESS_SITES: 'waterAccessSites',
  FISH_TYPES: 'fishTypes',
  AREA: 'area',
  TROPHY_FISH: 'trophyFish',
  ABUNDANT_FISH: 'abundantFish',
  KEEPER_FISH: 'keeperFish',
  STOCKING_EFFORT: 'highStockingEffortFish',
}

export const FISHING_SLUGS = [
  SLUGS.SHORE_FISHING,
  SLUGS.PIER_FISHING,
  SLUGS.BANK_FISHING,
  SLUGS.BREAKWATER_FISHING,
]

export const PARKING_SLUGS = [SLUGS.ADA_PARKING, SLUGS.TRAILER_PARKING]

export const SURFACE_TYPE_SLUGS = [
  SLUGS.GRAVEL_RAMP,
  SLUGS.PAVED_RAMP,
  SLUGS.NATURAL_RAMP,
]

export const LAUNCH_SLUGS = [SLUGS.TRAILER_LAUNCH, SLUGS.CARRY_IN]

export const SPECIES_SLUGS = [
  SLUGS.LARGEMOUTH_BASS,
  SLUGS.SMALLMOUTH_BASS,
  SLUGS.BLUEGILL,
  SLUGS.CRAPPIE,
  SLUGS.PERCH,
  SLUGS.MUSKELLUNGE,
  SLUGS.NORTHERN_PIKE,
  SLUGS.RAINBOW_TROUT,
  SLUGS.WALLEYE,
  SLUGS.LAKE_TROUT,
]
